module.exports = __webpack_public_path__ + "img/startConfigurationMemoires@2x.c5955ff.webp";